import { Component, computed, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import type { OpeningHoursDto } from '../../models/restaurant-api.model';
import { RestaurantConfigService } from '../../services/restaurant-config.service';

const DAY_LABELS: Record<number, string> = {
  1: 'Hétfő',
  2: 'Kedd',
  3: 'Szerda',
  4: 'Csütörtök',
  5: 'Péntek',
  6: 'Szombat',
  7: 'Vasárnap',
};

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
})
export class ContactComponent {
  private readonly sanitizer = inject(DomSanitizer);
  readonly restaurantConfig = inject(RestaurantConfigService);

  readonly profile = this.restaurantConfig.profile;
  readonly initialized = this.restaurantConfig.initialized;

  readonly safeMapUrl = computed((): SafeResourceUrl | null => {
    const url = this.restaurantConfig.contactInfo()?.googleMapsEmbedUrl?.trim();
    if (!url) {
      return null;
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  });

  readonly mapTitle = computed(
    () => `${this.profile()?.name ?? 'Kanyar Büfé'} helye a térképen – Pákozd, Velencei-tó`
  );

  readonly openingHourRows = computed(() => {
    const rows = this.restaurantConfig.openingHours();
    if (!rows?.length) {
      return [];
    }
    return [...rows]
      .sort((a, b) => a.dayOfWeek - b.dayOfWeek)
      .map((row) => ({
        day: DAY_LABELS[row.dayOfWeek] ?? `Nap ${row.dayOfWeek}`,
        hours: formatOpeningHours(row),
      }));
  });

  phoneHref(phone: string): string {
    return phone.replace(/\s/g, '');
  }
}

function formatOpeningHours(row: OpeningHoursDto): string {
  if (row.isClosed) {
    return 'Zárva';
  }
  if (row.openTime && row.closeTime) {
    return `${trimTime(row.openTime)} – ${trimTime(row.closeTime)}`;
  }
  return '—';
}

function trimTime(t: string): string {
  const m = t.match(/^(\d{1,2}):(\d{2})/);
  return m ? `${parseInt(m[1], 10)}:${m[2]}` : t;
}
